import React from 'react';
import { Field, Input } from '@fluentui/react-components';

export interface NormalizedRetentionPolicy {
  default_days: number;
  minimum_days: number;
  maximum_days: number;
}

interface NormalizedRetentionFieldProps {
  value?: number;
  policy: NormalizedRetentionPolicy;
  disabled?: boolean;
  onChange: (days: number) => void;
}

export const NormalizedRetentionField: React.FC<NormalizedRetentionFieldProps> = ({
  value, policy, disabled, onChange,
}) => (
  <Field label="Ingested table retention (days)"
    hint={`Keeps normalized ingested rows by UTC event time. Default: ${policy.default_days} days. Raw audit files are retained separately.`}>
    <Input type="number" min={policy.minimum_days} max={policy.maximum_days} step={1}
      disabled={disabled} value={String(value ?? policy.default_days)}
      placeholder={String(policy.default_days)} onChange={(_, data) => {
        const days = data.value === '' ? policy.default_days : Number(data.value);
        if (Number.isInteger(days) && days >= policy.minimum_days && days <= policy.maximum_days) {
          onChange(days);
        }
      }} />
  </Field>
);